import { render } from "./AuditLogExportFile.vue?vue&type=template&id=f4160512"
import script from "./AuditLogExportFile.vue?vue&type=script&lang=js"
export * from "./AuditLogExportFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__